import { Component, Input } from "@angular/core";

@Component({
    selector: "person-with-date",
    template: `
        <tooltip-date [for]="isoString"></tooltip-date><br />
        <span *ngIf="personId || isSystem" class="de-emphasize">
                    {{ "BY_LOWERCASE" | localize }}
            <person-name [id]="personId"
                         [isSystem]="isSystem">
            </person-name>
        </span>
    `,
})
export class PersonWithDateComponent {
    @Input() personId: uuid;
    @Input() isSystem: boolean;
    @Input() isoString: string;
}
